export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13464.275d3c68.jpg";